import { forwardRef } from 'react';

import {
  TableHeader as RACTableHeader,
  type TableHeaderProps as RACTableHeaderProps,
} from 'react-aria-components/Table';

export type TableHeaderProps<T = object> = RACTableHeaderProps<T> & {
  className?: string;
};

/**
 * TableHeader - Container for table column headers.
 */
export const TableHeader = forwardRef<
  HTMLTableSectionElement,
  TableHeaderProps
>(({ className, children, ...props }, ref) => {
  return (
    <RACTableHeader className={className} ref={ref} {...props}>
      {children}
    </RACTableHeader>
  );
});
